import { render } from "./Carousel-list.vue?vue&type=template&id=d405572a&scoped=true"
import script from "./Carousel-list.vue?vue&type=script&lang=js"
export * from "./Carousel-list.vue?vue&type=script&lang=js"

import "./Carousel-list.vue?vue&type=style&index=0&id=d405572a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d405572a"]])

export default __exports__